import { type FormInstance } from 'antd';
import { AppForm, AppFormItem, formRules } from 'shared/UI/UIKit/Form';
import { AppInput } from 'shared/UI/UIKit/Input';
import { AppTable } from 'shared/UI/UIKit/Table';
import type { Bell, BellSchedule } from 'services/api';
import { useBellScheduleForm } from '../model';
import { validateBellScheduleBells } from '../model/validators';
import styles from './styles.module.scss';

interface BellScheduleFormProps {
  form: FormInstance<BellSchedule>;
  readOnly?: boolean;
}

export const BellScheduleForm = ({ form, readOnly }: BellScheduleFormProps) => {
  const {
    state: { bells, columns, getRowClassName },
  } = useBellScheduleForm(form, readOnly, styles.shiftSeparator);

  return (
    <AppForm form={form} disabled={readOnly}>
      <AppFormItem name="name" label="Название" rules={formRules.required}>
        <AppInput placeholder="Введите название" />
      </AppFormItem>

      <AppFormItem
        name="bells"
        rules={[
          {
            validator: (_, value: Bell[]) => {
              const error = validateBellScheduleBells(value ?? []);
              if (error) {
                return Promise.reject(error);
              }

              return Promise.resolve();
            },
          },
        ]}
      >
        <AppInput type="hidden" />
      </AppFormItem>

      <AppTable
        columns={columns}
        dataSource={bells}
        rowKey={(record) => `${record.lessonIndex}-${record.shift}`}
        rowClassName={getRowClassName}
        size="small"
      />
    </AppForm>
  );
};
